import { ChangeDetectionStrategy, Component, signal, viewChild } from '@angular/core';
import { Film } from '../film/film';
import { FilmAction, FilmChapter, FilmEvent } from '../film/film.types';
import { Chapter, CHAPTERS, FABRIC_COLOURS } from './chapters';

/**
 * The hero: a 3D tour of the range, one model from each category, plus the
 * bits only the hero has — each model's name and price, and the colour
 * swatches of a sofa chapter.
 */
@Component({
  selector: 'app-hero',
  imports: [Film],
  templateUrl: './hero.html',
  styleUrl: './hero.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Hero {
  protected readonly chapters = CHAPTERS;
  protected readonly colours = FABRIC_COLOURS;
  protected readonly actions: FilmAction[] = [
    { label: 'Explore Recliners', href: '#collections', kind: 'primary' },
    { label: 'Enquire Now', href: '#enquire', kind: 'ghost' },
  ];
  /** the 3D scene is its own chunk, fetched when the film starts */
  protected readonly loader = () => import('./hero-scene').then((m) => m.HeroScene);

  /** which colour the sofa is currently wearing */
  protected readonly colour = signal(0);

  private readonly film = viewChild.required(Film);

  /** The film hands its chapters back as the generic type; ours also carry a product. */
  protected product(chapter: FilmChapter): Chapter['product'] {
    return (chapter as Chapter).product;
  }

  protected onStageEvent(event: FilmEvent): void {
    if (event.name === 'colour') this.colour.set(event.value);
  }

  protected pickColour(index: number): void {
    this.film().send('colour', index);
  }
}
